import React, {useEffect , useMemo} from 'react';
import {connect} from 'react-redux';
import {GetOrganizationFamilyData, saveToHistory, pushToHistory, backHistory, clearHistory, setShowPopup, setCurrentStep, AssignBenefitsToOrgFamilyMember } from './OrganizationEmployeeSlice';
import {FLOW_STEPS , familyMemberTexts, HeaderByStep} from './Conatant';
import BenefitsSelectionStep from './Steps/BenefitsSelectionStep';
import RecipientSelectionStep from './Steps/RecipientSelectionStep';
import AllocationStep from './Steps/AllocationStep';
import './OrganizationEmployee.scss';
import Popup from '../../Shared/Popup/PopUp';
import GeneralMessage from './GeneralMessage';
import backArrow from './icons/backArrow.svg';
import Image from '../../Shared/Image/image';
function OrgEmployeePageMain(props) {
  useEffect(() => {
    getFamiyMemberSettings();
    // return () => {
    //   props.clearHistory();
    // }
  }, []);


  useEffect(() => {
   window.scrollTo(0, 0);
  }, [props.currentStep]);

  const getFamiyMemberSettings = async () => {
    await props.GetOrganizationFamilyData({});
  };

  

  const popupActions = async (buttonAction) => {
    switch (buttonAction) {
      case 'goToBenefits':
         props.setCurrentStep(FLOW_STEPS.BENEFITS);
        break;
      case 'assignBenefits':
         await props.AssignBenefitsToOrgFamilyMember(props.messageData.params);
        break;
      case 'clearHistory':
         await props.clearHistory();
         await props.GetOrganizationFamilyData({});
        break;
      default:
        break;
    }
  }


  const getCurrentStep = useMemo(() => {
    window.scrollTo(0, 0);
    var currentPath = window.location.href.split('#')[1];
    if (props.currentStep !== currentPath) {
        props.pushToHistory(props.currentStep);
      }

      const STEP_COMPONENTS = {
        [FLOW_STEPS.BENEFITS]: BenefitsSelectionStep,
        [FLOW_STEPS.RECIPIENT]: RecipientSelectionStep,
        [FLOW_STEPS.ALLOCATION]: AllocationStep,
      };

        const Step = STEP_COMPONENTS[props.currentStep];
        return Step ? <Step className={`step ${props.currentStep}`} /> : null;
  
  }, [props.currentStep ]);


  const header = useMemo(() => {
    const headerData = HeaderByStep[props.currentStep];
    var title = headerData.title.replace('{orgName}', props.orgName || '');
    var subtitle = headerData.subtitle;
    if (headerData.TextfromEpi) {
      title = props.iContent?.title?.value || title;
      subtitle = props.iContent?.subtitle?.value || subtitle;
    }
    return (
      <div className='header'>
        {props.currentStep !== FLOW_STEPS.BENEFITS && (
          <button type='button' className='back-link' onClick={() => props.backHistory()}>
            <Image src={backArrow} alt='back' />
            {familyMemberTexts.back}
          </button>
        )}
        <span className='M_Title'>{title}</span>
        {subtitle && <span className='M_SubTitle'>{subtitle}</span>}
      </div>
    )
  }, [props.currentStep, props.orgName]);

  return (
    <div className='OrganizationFamilyMember'>
      <div className='page-container'>
        {header}
        {getCurrentStep}
      </div>
      {props.messageData?.isPopup && (
        <Popup className='mainPopup' showPopUp={props.showPopup} onClose={() =>{ 
          props.setShowPopup(false); popupActions(props.messageData.closePopup)}}>
            <GeneralMessage popupActions={ (buttonAction) => popupActions(buttonAction) } 
            messageData={props.messageData} 
            data ={props.data}
            setShowPopup={props.setShowPopup}
            />
        </Popup>
      )}
    </div>
  );
}

const mapStateToProps = (state) => ({
  productsDescription: state.organizationEmployee.productsDescription,
  currentStep: state.organizationEmployee.currentStep,
  messageData: state.organizationEmployee.messageData,
  showPopup: state.organizationEmployee.showPopup,
  orgName: state.organizationEmployee.orgName,
  data: state.organizationEmployee,
});

const mapDispatchToProps = {
  saveToHistory,
  GetOrganizationFamilyData,
  pushToHistory,
  backHistory,
  clearHistory,
  setShowPopup,
  setCurrentStep,
  AssignBenefitsToOrgFamilyMember,
};

export default connect(mapStateToProps, mapDispatchToProps)(OrgEmployeePageMain);
